import { ApiError, httpStatusMessage } from './errors';
import { readNdjsonStream } from './stream';
export function buildUrl(baseUrl, path, query) {
    const base = baseUrl.replace(/\/+$/, '');
    const url = new URL(base + path);
    if (query) {
        for (const [key, value] of Object.entries(query)) {
            if (value === undefined)
                continue;
            if (Array.isArray(value)) {
                for (const v of value)
                    url.searchParams.append(key, String(v));
            }
            else {
                url.searchParams.set(key, String(value));
            }
        }
    }
    return url.toString();
}
async function toApiError(res) {
    let status;
    try {
        status = (await res.json());
    }
    catch {
        // non-JSON error body (e.g. ingress-auth plain 401) — fall through
    }
    const message = status?.message ?? httpStatusMessage(res.status);
    return new ApiError(message, res.status, status?.code, status?.details);
}
export function createFetchTransport(cfg) {
    const fetchImpl = cfg.fetchImpl ?? fetch;
    async function doFetch(method, path, opts, accept) {
        // spread extras FIRST so the reserved headers below always win
        const headers = { ...(cfg.extraHeaders?.() ?? {}), ...(opts.headers ?? {}), Accept: accept };
        const token = cfg.getAccessToken ? await cfg.getAccessToken() : null;
        if (token)
            headers['Authorization'] = `Bearer ${token}`;
        let body;
        if (opts.body !== undefined) {
            headers['Content-Type'] = 'application/json';
            body = JSON.stringify(opts.body);
        }
        let res;
        try {
            res = await fetchImpl(buildUrl(cfg.baseUrl, path, opts.query), { method, headers, body, signal: opts.signal });
        }
        catch (err) {
            if (err instanceof DOMException && err.name === 'AbortError')
                throw err;
            const apiErr = new ApiError(err instanceof Error ? err.message : 'network error', 0);
            cfg.onError?.(apiErr);
            throw apiErr;
        }
        if (!res.ok) {
            const apiErr = await toApiError(res);
            cfg.onError?.(apiErr);
            throw apiErr;
        }
        return res;
    }
    return {
        async request(method, path, opts = {}) {
            const res = await doFetch(method, path, opts, 'application/json');
            return (await res.json());
        },
        requestStream(method, path, opts = {}) {
            async function* generate() {
                const res = await doFetch(method, path, opts, 'application/json');
                yield* readNdjsonStream(res);
            }
            return generate();
        },
    };
}
//# sourceMappingURL=transport.js.map